module.exports = __webpack_public_path__ + "img/feedback5-1.f5156736.jpg";